import {shadow, rgba} from '@packages/utilities/inline-style-utils';
import {styledDiv} from '@packages/utilities/styled';

export const getBoxShadow = (
  noShadow: boolean,
  shadowOpacity: number = 0.15
) => [noShadow ? null : shadow(0, 5, 10, rgba(0, 0, 0, shadowOpacity))];

export const Card = styledDiv(
  ({theme, noShadow, style}) => ({
    borderWidth:
      style?.borderWidth || theme.card.borderWidth || theme.control.borderWidth,
    borderStyle: 'solid',
    borderColor: theme.colors.deepBackground,
    borderRadius: style?.borderRadius || theme.card.borderRadius,
    boxShadow: noShadow ? null : theme.popover.boxShadow,
    overflow: 'hidden',
    ...style,
  }),
  {
    noBorder: {
      borderWidth: 0,
      borderStyle: 'none',
    },
  }
);
